import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewContractPymesService } from 'src/app/services/new-contract-pymes.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InstallationSavedData, RazonSocial, AnalysisSavedData, PaymentSavedData } from 'src/app/interfaces';
import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-resume-dialog',
  templateUrl: './resume-dialog.component.html',
  styleUrls: ['./resume-dialog.component.scss']
})
export class ResumeDialogComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  public analysisOpen = false;
  public businessOpen = false;
  public installationOpen = false;
  public paymentOpen = false;
  public savedDataBusiness: RazonSocial;
  public savedDataInstallation: InstallationSavedData;
  public savedDataAnalysis: AnalysisSavedData;
  public savedDataPayment: PaymentSavedData;
  public isUserSpanish = true;

  constructor(
    public dialogRef: MatDialogRef<ResumeDialogComponent>,
    private newContractService: NewContractPymesService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public tabIndex: any
  ) { }

  ngOnInit(): void {
    this.isUserSpanish = this.authService.getUserData().country === 'ES';
    this.getSavedData();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getSavedData(): void {
    this.newContractService.getSavedData().pipe(takeUntil(this.destroyed$)).subscribe(res => {
      if (res) {
        this.savedDataBusiness = res.business;
        this.savedDataInstallation = res.installation;
        this.savedDataAnalysis = res.analysis;
        this.savedDataPayment = res.payment;
        if (this.tabIndex === 1) {
          this.toggleAnalysis();
        }
      }
    });
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public toggleAnalysis(): void {
    this.analysisOpen = !this.analysisOpen;
  }
  public toggleBusiness(): void {
    this.businessOpen = !this.businessOpen;
  }
  public toggleInstallation(): void {
    this.installationOpen = !this.installationOpen;
  }
  public togglePayment(): void {
    this.paymentOpen = !this.paymentOpen;
  }
}
